import { render, staticRenderFns } from "./PriceCard.vue?vue&type=template&id=42faad7d&scoped=true&"
import script from "./PriceCard.vue?vue&type=script&lang=ts&"
export * from "./PriceCard.vue?vue&type=script&lang=ts&"
import style0 from "./PriceCard.vue?vue&type=style&index=0&id=42faad7d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42faad7d",
  null
  
)

export default component.exports